var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "fieldset",
    { staticClass: "option-select option-select--buttons" },
    [
      _vm.label
        ? _c("legend", { staticClass: "option-select__legend" }, [
            _c(
              "span",
              { staticClass: "option-select__legend--title u-sr-only" },
              [_vm._v(_vm._s(_vm.label))]
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "option-select__label-wrapper" },
        _vm._l(_vm.optionSet, function (option) {
          return _c(
            "label",
            {
              staticClass: "option-select__label",
              class: { "is-selected": option.value === _vm.value },
              attrs: { tabindex: "0", disabled: option.disabled },
            },
            [
              _c("icon", {
                staticClass: "option-select__icon",
                attrs: { name: option.icon, width: "60px", height: "60px" },
              }),
              _c("div", { staticClass: "option-select__label__title" }, [
                _vm._v(_vm._s(option.label)),
              ]),
              _c("input", {
                staticClass: "u-sr-only",
                attrs: {
                  type: "radio",
                  tabindex: "-1",
                  id: option.label,
                  disabled: option.disabled,
                  name: "type",
                },
                domProps: {
                  value: option.value,
                  checked: option.value === _vm.value,
                },
                on: {
                  change: function ($event) {
                    return _vm.onChange(option.value)
                  },
                },
              }),
            ],
            1
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }